import React from 'react';

import { Box, CircularProgress } from '@material-ui/core';

export const OnboardingLoader: React.FC = () => (
  <Box display="flex" alignItems="center" justifyContent="center" minHeight="80vh" width="100%">
    <CircularProgress size={48} />
  </Box>
);
